import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppConfigService } from '../../services/app-config.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'lib-contact-button',
  templateUrl: './contact-button.component.html',
  styleUrls: ['./contact-button.component.scss'],
  standalone: false
})
export class ContactButtonComponent implements OnInit {
  public showIdeaButton = false;
  public showContactButton = false;
  public showFaqButton = false;
  public showCsrContactForm = false;

  public showIdeaForm = false;
  public showContactForm = false;
  public showReviewForm = false;
  public showRootButton = false;

  public get showButtons() {
    return !this.showIdeaForm && !this.showContactForm && !this.showReviewForm;
  }

  private modalRef: NgbModalRef;
  constructor(
    private modalService: NgbModal,
    private appConfigService: AppConfigService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const config = this.appConfigService.getConfig();
    this.showIdeaButton = config.EnableShareIdeaButton;
    this.showContactButton = config.EnableContactUsButton;
    this.showFaqButton = config.EnableFaqButton;
    this.showCsrContactForm = config.EnableCsrHelpForm;
    this.authService.userLoginStatus.subscribe(result => {
      this.showRootButton = result && this.authService.isInAllowedRole();
    });
  }

  public open(content) {
    this.modalRef = this.modalService.open(content, {
      size: 'lg',
      windowClass: 'get-help',
      animation: false,
      backdrop: true,
      backdropClass: 'get-help-modal-backdrop'
    });
    this.modalRef.dismissed.subscribe(_ => this.modalDismissed());
  }

  public ideaButtonClicked() {
    this.showIdeaForm = true;
  }

  public contactButtonClicked() {
    this.showContactForm = true;
    if (this.showCsrContactForm) {
      setTimeout(() => {}, 1000);
    }
  }

  public modalDismissed() {
    this.showIdeaForm = false;
    this.showContactForm = false;
    this.showReviewForm = false;
  }

  public closeModal() {
    this.showIdeaForm = false;
    this.showContactForm = false;
    this.showReviewForm = false;
    this.modalRef.close();
  }
}
